// **********************************************************
// House Plan Toggle
// **********************************************************

const houseMatrixContent = document.querySelector('.house-matrix__content');

if (houseMatrixContent) {
  attachEvent('.house-matrix .house-info .mod-toggle__input', 'change', (ele) => {
    const parentEle = ele.target.closest('.house-info');
    parentEle.classList.toggle('is-plan-visible');
  });
}
